import DataGridActionHeader from "components/common/controls/grid/DataGridActionHeader";
import CreateTokenPopup from "./CreateTokenPopup";
import { useMemo, useState } from "react";
import React from "react";
import ManageTokenGridFilter from "./ManageTokenGridFilter";

interface Props {
  onFilterChange: (selectedOption: any) => void;
}

export const ManageTokenGridActionHeader = React.memo((props: Props) => {
  const { onFilterChange } = props;
  const [isCreateNewTokenPopupVisible, setIsCreateNewTokenPopupVisible] =
    useState(false);
  const handleCreateNewTokenClick = () => {
    setIsCreateNewTokenPopupVisible(true);
  };

  const FilterComponent = useMemo(
    () => () => {
      return <ManageTokenGridFilter onFilterChange={onFilterChange} />;
    },
    [onFilterChange]
  );

  return (
    <>
      <DataGridActionHeader
        displayNew={true}
        newButtonText="New Token"
        onNewClick={handleCreateNewTokenClick}
        filterComponent={FilterComponent}
      />
      {isCreateNewTokenPopupVisible && (
        <CreateTokenPopup
          onClose={() => setIsCreateNewTokenPopupVisible(false)}
        />
      )}
    </>
  );
});

export default ManageTokenGridActionHeader;
